import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import UserForUserGroupApiUrls from 'src/apiUrls/UserForUserGroupApiUrls'
import React from 'react'
import UserForUserGroupKeys from 'src/constants/locale/key/UserForUserGroup'
import Namespace from 'src/constants/locale/Namespace'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    useDefaultNotification,
    useFetchCustomLookup
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const notification = useDefaultNotification(showNotification)

  const fetchCustomLookup = useFetchCustomLookup()

  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.USER_FOR_USER_GROUP
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let userForUserGroup = translate(
      Namespace.USER_FOR_USER_GROUP,
      UserForUserGroupKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: userForUserGroup
      }
    )
    let partyId = translate(
      Namespace.USER_FOR_USER_GROUP,
      UserForUserGroupKeys.PARTY_ID
    )
    let loginId = translate(
      Namespace.USER_FOR_USER_GROUP,
      UserForUserGroupKeys.LOGIN_ID
    )

    return {
      userForUserGroup,
      tableTitle,
      partyId,
      loginId
    }
  }

  const columns = [
    {
      field: 'partyId',
      title: translatedTextsObject.partyId,
      customLookup: () => {
        return fetchCustomLookup(
            `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/party/get`,
            { },
            'content',
            'name',
            'id',
            (error) => console.error(error)
        )
      },
    },
    {
      field: 'userProfileId',
      title: translatedTextsObject.loginId,
      customLookup: () => {
        return fetchCustomLookup(
            `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/get`,
            { },
            'content',
            'loginId',
            'id',
            (error) => console.error(error)
        )
      },
    }
  ];

	return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
							fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
              addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: UserForUserGroupApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              exportData={{ url: UserForUserGroupApiUrls.EXPORT }}
              fetch={{ url: UserForUserGroupApiUrls.GET_USER_DETAIL }}
              idAccessor='id'
              notification={notification}
              tableConfigurationCode='USER_GROUP_USER'
              viewRoute={`${pathname}/view`}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default TablePage
